const baseURL = "https://api.remotejobs.quaxo.net";
// const baseURL = "http://localhost:8080";
const isAdmin = false;

export default { baseURL, isAdmin };
